<template>
  <el-drawer size="620px"
             :withHeader="false"
             :visible.sync="logVisible"
             :close-on-press-escape="false"
             :wrapperClosable="false"
             :before-close="handleClickClose">
    <div class="drawer_wrap">
      <div class="drawer_header">
        <h3 class="title">操作详情：<span v-text="productName"></span> </h3>
        <i class="el-icon-close" @click="handleClickClose"></i>
      </div>
        <div class="drawer_body" v-loading="loading">
        <el-divider v-if="!loading && logsList.length === 0" v-cloak>暂无数据</el-divider>
        <div class="detail_container" v-if="logsList.length !== 0" >
<!--          <div class="detail_title">操作详情</div>-->
          <ul :infinite-scroll-distance="20"  :infinite-scroll-immediate="false" class="infinite-list"  v-infinite-scroll="() => productLoadMoreData()">
            <li v-for="item in logsList">
<!--              <div class="top">-->
<!-- <div v-text="item.operate_type"></div>-->
<!--          <div>激活码 <p v-text="item.operate_content ? item.operate_content.license_code : ''"></p></div>-->
<!-- <span class="template_color" @click="handleClickDownUp(item)" v-text="item.downUp ? '收起' :'展开'"></span>-->
<!--              </div>-->
              <div class="bottom" v-if="item.downUp">
<!--                <div class="left">-->
<!--                  <p v-text="item.create_date"></p>-->
<!--                  &lt;!&ndash;                  <p v-text="item.operate_type"></p>&ndash;&gt;-->
<!--                </div>-->
                <div class="right">
                  <div class="field_list">
                    <div class="field_name"> <strong>操作类型：</strong> </div>
                    <div class="field_value" ><strong v-text="item.operate_type"></strong></div>
                  </div>
                  <div class="field_list">
                    <div class="field_name">操作人：</div>
                    <div class="field_value" v-text="item.name"></div>
                  </div>
                  <div class="field_list">
                    <div class="field_name">操作时间：</div>
                    <div class="field_value" v-if="item.create_date" v-text="convertToCurrentTimezone(item.create_date,'/','datetime')"></div>
                  </div>
                  <!--                              <div class="field_list">-->
                  <!--                                <div class="field_name">-->
                  <!--                                  操作状态：-->
                  <!--                                </div>-->
                  <!--                                <div class="field_value">-->
                  <!--                                  已完成-->
                  <!--                                </div>-->
                  <!--                              </div>-->
                  <div class="field_list"  v-if="item.operate_content && item.operate_content.license_code">
                    <div class="field_name">激活码：</div>
                    <div class="field_value">
                      <span  v-text="item.operate_content ? item.operate_content.license_code : ''"></span>
                      <span class="template_color copy_btn" @click="handleClickCopy(item.operate_content.license_code)">复制</span>
                    </div>
                  </div>

                  <div class="field_list">
                    <div class="field_name">模块信息：</div>
                    <div class="field_value">
                      <p v-for="list in item.operate_content.license_modules">
                        <span v-text="list.module ? list.module.module_name : ''"></span> :
                        <span v-text="list.module_value ? list.module_value : ''"></span>
                      </p>
                    </div>
                  </div>

                  <div class="field_list">
                    <div class="field_name">有效期截止日：</div>
                    <div class="field_value" v-if="item.operate_content && item.operate_content.start_date" v-text="convertToCurrentTimezone(item.operate_content.start_date,'/','datetime') +' ~ '+ convertToCurrentTimezone(item.operate_content.end_date,'/','datetime') "></div>
                  </div>

                  <div class="field_list">
                    <div class="field_name"> 硬件ID：</div>
                    <div class="field_value" v-text="item.operate_content ? item.operate_content.machine_id : ''"></div>
                  </div>


                </div>


              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </el-drawer>
</template>
<script>
import {adminLicenseLogs} from '@/api/api'
import {pagination} from '@/mixins'
import {convertToCurrentTimezone} from '@/utils'
export default {
  name: 'productLog',
  props: {
   logVisible: {
      type: Boolean,
      default: false,
    },
    logId: {
      type: Number,
      default: 0,
    },
    productName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading:false,
      logsList:[]
    }
  },
  mixins: [pagination],
  computed: {

  },
  mounted() {
    this.getProductLicenseLogs()
  },

  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    getProductLicenseLogs(){
      this.loading = true
      let postData = {
        id:this.logId,
        page: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      }
      adminLicenseLogs(postData).then(res => {
        if (res.code === 200) {
          let {total, data} = res.data
          data.forEach((item)=>{
            this.$set(item,'downUp',true)
          })
          this.logsList = data
          this.pagination.total = total
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 滚动加载物品列表
    productLoadMoreData(){
      if(this.logsList || this.logsList.length == this.pagination.total){
        return false
      }
      this.pagination.pageNum = this.pagination.pageNum + 1
      this.getProductLicenseLogs()
    },

    handleClickDownUp(item){
      this.$set(item,'downUp',!item.downUp)
    },
    // 复制
    handleClickCopy(value){
      const textToCopy = value;
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      // 选中文本并复制
      textarea.select();
      document.execCommand('copy');
      // 移除临时元素
      document.body.removeChild(textarea);
      this.$message({
        showClose: true,
        message: '复制成功',
        type: 'success',
        duration: 1500,
        onClose: () => { }
      });
    },

    //取消事件
    handleClickClose() {
      //关闭对话框
      this.$emit('update:logVisible', false)
    },

  },
}
</script>
<style lang="scss" scoped>
.detail_container{

  width:100%;
  background: rgba(250, 250, 250, 1);
  padding:0 16px;
  height: calc(100vh - 80px);
  overflow: auto;
  box-sizing: border-box;
  .detail_title{
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
  }
  ul{
    width: 100%;
    li{
      width: 100%;
      border-bottom:  1px solid rgba(217, 217, 217, 1);
      padding-bottom: 12px;
      padding-top: 12px;
      &:last-child{
        border-bottom: 0;
        padding-bottom:0
      }
      .top{
        padding:7px 0;
        padding-right: 40px;
        box-sizing: border-box;
        position: relative;
        div{
          color: rgba(51, 51, 51, 1);
          line-height: 22px;
          font-weight: bold;
          font-size: 12px;
          p{
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
            margin-left: 14px;
            display: inline-block;
          }
        }
        span{
          position: absolute;
          right: 0;
          top: 7px;
          line-height: 22px;
          cursor: pointer;
        }
      }

      .bottom{
        width: 100%;
        display: flex;
        justify-content: space-between;

        .left{
          width: 82px;
          padding-right: 8px;
          box-sizing: border-box;
          p{
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 3px;
          }
        }
        .right{
          width: 100%;

          .field_list{
            margin-bottom: 4px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            .field_name{
              width: 100px;
            }
            .field_value{
              width: calc(100% - 100px);
              word-wrap: break-word;
              span.copy_btn{
                //float: right;
                margin-left: 10px;
              }
            }
          }
        }
      }

    }
  }
}
</style>
